import { Component } from '@angular/core';
import { EmptyStateComponent } from '../../core/panels/empty-state.component';

@Component({
  selector: 'app-forbidden-page',

  imports: [EmptyStateComponent],
  template: `
    <div class="tw-flex tw-items-center tw-justify-center tw-h-full">
      <app-empty-state
        icon="fa-light fa-lock-keyhole"
        label="403 Forbidden"
        message="Authorization required to access this resource"
      />
    </div>
  `,
  styles: [``],
})
export class ForbiddenPageComponent {}
